import React from 'react';
import { Section } from '@antonpodolsky/design-system/regions/section/section';
import { NumberedList } from '@antonpodolsky/design-system/data-display/numbered-list/numbered-list';
import { NumberedListItem } from '@antonpodolsky/design-system/data-display/numbered-list-item/numbered-list-item';

export const HomepageAudience = () => (
  <Section width="sm" compact title="Who is Exify for?">
    <NumberedList>
      <NumberedListItem title="Photographers">
        Learn what gear and camera settings were used to capture a photo.
      </NumberedListItem>

      <NumberedListItem title="Researchers / OSINT">
        Dive deeper into image metadata for analysis and investigations.
      </NumberedListItem>

      <NumberedListItem title="Anyone curious about images">
        Get quick access to image metadata on any website.
      </NumberedListItem>
    </NumberedList>
  </Section>
);
